module.exports = __webpack_public_path__ + "img/mysql.af0dad0a.webp";